import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faList, faBox, faReceipt } from '@fortawesome/free-solid-svg-icons';
import AdminShopCategories from './AdminShopCategories';
import AdminShopProducts from './AdminShopProducts';
import AdminShopOrders from './AdminShopOrders';
import './AdminShop.css';

const AdminShop = () => {
  const [activeTab, setActiveTab] = useState('categories');

  return (
    <div className="admin-shop">
      <div className="page-header">
        <h2><FontAwesomeIcon icon={faBox} /> Quản lý Cửa hàng</h2>
      </div>

      <div className="tabs-container">
        <div className="tabs">
          <button
            className={`tab ${activeTab === 'categories' ? 'active' : ''}`}
            onClick={() => setActiveTab('categories')}
          >
            <FontAwesomeIcon icon={faList} /> Danh mục
          </button>
          <button
            className={`tab ${activeTab === 'products' ? 'active' : ''}`}
            onClick={() => setActiveTab('products')}
          >
            <FontAwesomeIcon icon={faBox} /> Sản phẩm
          </button>
          <button
            className={`tab ${activeTab === 'orders' ? 'active' : ''}`}
            onClick={() => setActiveTab('orders')}
          >
            <FontAwesomeIcon icon={faReceipt} /> Đơn hàng
          </button>
        </div>

        <div className="tab-content">
          {activeTab === 'categories' && <AdminShopCategories />}
          {activeTab === 'products' && <AdminShopProducts />}
          {activeTab === 'orders' && <AdminShopOrders />}
        </div>
      </div>
    </div>
  );
};

export default AdminShop;
